export default __webpack_public_path__ + "f2fae251013fae9139267be3121ee45b.svg";